import { useCallback, useState } from "react";
import { isEmpty } from "lodash";
import { useItemGroups } from "atoms/itemsGropAtom";
import { ItemsGroupWithChildren, ItemsGroup } from "types";
import { useSetAtom } from "jotai/index";
import { allItemGroups } from "constant-data/items";

import { Accordion } from "components/Accordion/Accordion";

import { setSettingsModalGroupAtom } from "../../../atoms/modalAtom/modalAtom";

import { transformItemsGroup } from "../helpers";
import styles from "../styles.module.scss";
import { useGetProductsGroup } from "../api";

import { ProductsGroupItem } from "./index";

export const ProductsGroupList: React.FC = () => {
  const setSettingsModalGroup = useSetAtom(setSettingsModalGroupAtom);

  const { itemGroupsState, setItemGroupsState } = useItemGroups();

  const { data = [] } = useGetProductsGroup({});

  const transformedItemGroups: ItemsGroupWithChildren[] = transformItemsGroup([
    ...data,
  ]);

  const [expandedAccordions, setExpandedAccordions] = useState<Set<string>>(
    new Set()
  );

  const changeSelected = useCallback(
    (newItem: ItemsGroup, shouldOpenAtDoubleClick: boolean) => {
      if (
        shouldOpenAtDoubleClick &&
        itemGroupsState.activeItemsGroup?.itemgroupid === newItem.itemgroupid &&
        newItem.itemgroupid !== allItemGroups.itemgroupid
      ) {
        setSettingsModalGroup(true);
      } else {
        setItemGroupsState({
          ...itemGroupsState,
          activeItemsGroup: newItem,
        });
      }
    },
    [setItemGroupsState, itemGroupsState]
  );

  const toggleAccordion = (itemgroupid: string) => {
    setExpandedAccordions((prevState) => {
      const newExpanded = new Set(prevState);
      if (newExpanded.has(itemgroupid)) {
        newExpanded.delete(itemgroupid);
      } else {
        newExpanded.add(itemgroupid);
      }
      return newExpanded;
    });
  };

  const renderItems = (items: ItemsGroupWithChildren[]) =>
    items.map((item) => {
      const { children } = item;

      if (children && children.length > 0) {
        return (
          <Accordion
            key={item.itemgroupid}
            withIcon
            collapsed={!expandedAccordions.has(item.itemgroupid || "")}
            parent={
              <ProductsGroupItem
                isActive={
                  item.itemgroupid ===
                  itemGroupsState.activeItemsGroup?.itemgroupid
                }
                onClick={() => {
                  toggleAccordion(item.itemgroupid || "");
                  changeSelected(item, false);
                }}
                name={item.name}
              />
            }
          >
            <div className="pl-5">{renderItems(children)}</div>
          </Accordion>
        );
      }

      return (
        <ProductsGroupItem
          key={item.itemgroupid}
          isActive={
            item.itemgroupid === itemGroupsState.activeItemsGroup?.itemgroupid
          }
          onClick={() => {
            changeSelected(item, true);
          }}
          name={item.name}
        />
      );
    });

  return (
    <div className={styles.productsList}>
      {!isEmpty(transformedItemGroups)
        ? renderItems([allItemGroups, ...transformedItemGroups])
        : renderItems([allItemGroups])}
    </div>
  );
};
